<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-09-06 15:35:08
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-06 15:35:09
-->
<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-09-05 21:42:33
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-06 01:07:15
-->
<template>
  <div class="table">
    <a-tabs>
      <a-tab-pane key="1" tab="政策申报管理">
        <!-- <div class="tool-box">
          <a-button @click="handleAdd" type="primary">申请</a-button>
        </div> -->
        <a-table :data-source="data" :columns="columns" rowKey="id" style="width: 100%">
          <span slot="agencyzId" slot-scope="text">{{ fmtAgency(text) }}</span>
          <span slot="status" slot-scope="text">{{ fmtStatus(text) }}</span>
          <template slot="operation" slot-scope="text, record">
            <!-- <a
              href="javascript:;"
              style="margin-right: 8px"
              @click="() => handleDetail(record)"
              >详情</a
            > -->
            <a
              href="javascript:;"
              style="margin-right: 8px"
              @click="() => handleDetail(record)"
              >审核反馈</a
            >
            <a
               v-if="record.auditStatus == '2'"
              href="javascript:;"
              style="margin-right: 8px"
              @click="() => handleEdit(record)"
              >修改</a
            >
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
    <a-modal
      :title="title"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
       cancelText="关闭"
      okText="确定"
    >
      <a-form-model v-model="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 8 }">
        <!--<a-form-model-item label="联系人">
          <a-input v-if="isEdit" v-model="form.concat" :disabled="!isEdit" />
          <span v-else>{{ form.concat }}</span>
        </a-form-model-item>
        <a-form-model-item label="联系电话">
          <a-input v-if="isEdit" v-model="form.phone" :disabled="!isEdit" />
          <span v-else>{{ form.phone }}</span>
        </a-form-model-item>
        <a-form-model-item label="邮箱">
          <a-input v-if="isEdit" v-model="form.email" :disabled="!isEdit" />
          <span v-else>{{ form.email }}</span>
        </a-form-model-item>-->
         
        <a-form-model-item label="附件">
          
          <a-upload
            :locale="locale"
            :showUploadList="true"
            name="file"
            action="/app/common/attachment"
            @change="handleChange"
          >
            <a-button> <a-icon type="upload" /> 上传 </a-button>
          </a-upload>
           
         
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal
      title="反馈记录"
      :visible="visible2"
      :confirm-loading="confirmLoading"
      :maskClosable="false"
      @cancel="visible2 = false"
       cancelText="关闭"
      okText="确定"
    >
      <a-table
        :data-source="shenhedata"
        :columns="columns2"
        rowKey="id"
        style="width: 100%"
      >
        <span slot="status" slot-scope="text">{{ fmtStatus(text) }}</span>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
const columns2 = [
  {
    title: "审核人",
    dataIndex: "auditName",
    key: "auditName",
  },
  {
    title: "审核时间",
    dataIndex: "createTime",
    key: "createTime",
  },
  {
    title: "审核状态",
    dataIndex: "status",
    key: "status",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "备注",
    dataIndex: "remark",
    key: "remark",
    width: 120,
  },
];
const columns = [
  {
    title: "申报标题",
    dataIndex: "shenName",
    key: "shenName",
    width: 500,
    ellipsis: true,
  },
  {
    title: "申报时间",
    dataIndex: "createTime",
    key: "createTime",
    width: 180,
    ellipsis: true,
  },
  {
    title: "状态",
    dataIndex: "auditStatus",
    key: "auditStatus",
    scopedSlots: { customRender: "status" },
    width:150,
    ellipsis: true,
  },
  {
    title: "操作",
    dataIndex: "operation",
    key: "id",
    scopedSlots: { customRender: "operation" },
  },
];
import qs from "qs";
import request from "../util/request";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
export default {
  name: "user-center-project",
  data() {
    return {
      locale,
      data: [],
      columns,
      columns2,
      type: [],
      org: [],
      shenhedata: [],
      page: {
        page: 1,
        pageSize: 999,
      },
      title: "",
      visible: false,
      visible2: false,
      detail: {},
      confirmLoading: false,
      isEdit: false,
      parents: [],
      fileList: [],
      form: {},
      status: ["待审核", "打回", "流转审核", "审核完毕"],
      userInfo: {},
    };
  },
  mounted() {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
      this.userInfo = JSON.parse(userInfo);
    }

    this.queryList();
    this.queryDict();
    this.queryOrg();
  },
  methods: {
    fmtStatus(text) {
      if (text == 1) {
        return "待审核";
      } else if (text == 2) {
        return "打回";
      } else if (text == 3) {
        return "流转审核";
      } else if (text == 4) {
        return "审核完毕";
      }
    },
    handleDetail(record) {
      request({
        url: `/api/center/shen/remark/${record.id}`,
      }).then((res) => {
        this.visible2 = true;
        this.shenhedata = res.data;
      });
    },

    handleChange(info) {
      if (info.file.status === "done") {
        if (this.form.fileId) {
          this.form.fileId.push(info.file.response.data.url);
        } else this.form.fileId = [info.file.response.data.url];
        this.$message.success(`${info.file.name} 文件上传成功`);
        console.log(this.form.fileId);
      }
    },
    onDelete(record) {
      request({
        url: "/api/center/order/shen/" + record.id,
        method: "delete",
      }).then((res) => {
        this.$message.info(res.msg);
        this.queryList();
      });
    },

    handleAdd(record) {
      this.title = "个人申报";
      this.isEdit = true;
      this.form = { shenId: record.id };
      this.visible = true;
    },
    handleEdit(record) {
      this.form.fileId = [];
      this.visible = true;
      this.title = "修改";
      this.form = JSON.parse(JSON.stringify(record));
      delete this.form.children;
      this.isEdit = true;
    },
    handleOk() {
      const params = Object.assign({}, this.form);

      console.log(this.form.fileId.join(","));

      params.fileId = this.form.fileId.join(",");
      request({
        url: "/api/center/shen/",
        method: "PUT",
        data: qs.stringify(params),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }).then((res) => {
        if (res.msg == "success") {
          this.$message.info("操作成功");
          this.visible = false;
          this.form = {};
          this.queryList();
        } else {
          this.$message.warning(res.msg);
        }
      });

      this.visible = false;
      this.form = {};
    },
    fmttype(text) {
      const result = this.type.find((ele) => ele.key == text);
      return result ? result.value : "";
    },
    fmtAgency(text) {
      const result = this.org.find((ele) => ele.key == text);
      return result ? result.value : "";
    },
    queryDict() {
      request({
        url: "/api/tool/select/dict/list",
        params: {
          key: "trademarkclassify",
        },
      }).then((res) => {
        console.log("dict", res);
        this.type = res.data;
      });
    },

    queryOrg() {
      request({
        url: "/api/tool/select/enterprise/list",
        params: {
          key: "ORG_OWNER",
        },
      }).then((res) => {
        this.org = res.data;
      });
    },
    queryList() {
      request({
        url: "/api/center/shen/list",
        params: this.page,
      }).then((res) => {
        if (res.code == "200") {
          this.data = res.data.records;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.form = false;
    },
  },
};
</script>

<style lang="less"></style>
